import React from 'react';
import { Navbar } from '../../components';
import { IcdHeader } from '../../containers';

const Icd = () => {
  return (
    <div>
        <div className="gradient__bg">
          <Navbar />
          <IcdHeader />
        </div>
    </div>
  )
}

export default Icd